import { Component, OnInit } from '@angular/core';
import { AddNewUserService } from '../services/add-new-user.service';
import { ProductKpiService } from '../services/product-kpi.service';


@Component({
  selector: 'cintas-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {
  products: any[] = [];

  // selectedRole: string = '';
  constructor(private AddNewUserService: AddNewUserService, private ProductService: ProductKpiService) { }

  startScanning() {
    const tagScanner = document.getElementById("tagScanner") as HTMLInputElement | null;
    if (tagScanner) {
      tagScanner.type = "text"
      tagScanner.value = "test"
    }
  }
  // onRoleChange(selectedRole: string): void {
  //   this.selectedRole = selectedRole;
  // }

  ngOnInit() {
    this.ProductService.getProductTypes().subscribe((response) => {
      this.products = response.data;
      console.log(this.products)
    });
  }

  onProductSelectionChange(product){
    product.selected = true
    console.log(product)
  }


  onSubmit(formValue: any) {
    const productDetails = this.products
      .filter(product => product.selected)
      .map(product => ({
        product_id: product.cuid,
        allowed_amount: product.takeoutLimit,
        remaining_amount: product.takeoutLimit
      }));

      console.log(productDetails)

    const formData = {
      full_name: formValue.full_name,
      email: formValue.email,
      // role: formValue.role,
      tag_id: formValue.tag_id,
      product_detail: productDetails
    };

    console.log(formData);

    this.AddNewUserService.addCustomer(formData).subscribe(
      (response) => {
        console.log('Cabinet user added successfully', response);
        alert('Cabinet user added successfully');
        // window.location.reload();
      },
      (error) => {
        if (error.status === 422) {
        const validationErrors = error.error.errors;
        if (validationErrors.email) {
          alert(validationErrors.email);
        }
        if (validationErrors.tag_id) {
          alert(validationErrors.tag_id);
        }
      } else {
        console.error('Please Try Again! Error adding cabinet user', error);
        alert('Please Try Again! Error adding cabinet user' + error.message);
      }
        // window.location.reload();
      }
    );
  }

}
